const Offcanvas = () => {
  
  let overlay = $('#offCanvas'),
    tl = null,
    menu = document.querySelector('.nav-overlay-menu'),
    its = gsap.utils.toArray('.nav-overlay-menu li'),
    nav1 = gsap.utils.toArray('.nav-overlay-menu .primary-menu li'),
    nav2 = gsap.utils.toArray('.nav-overlay-menu .social-menu li'),
    bg = document.querySelector('.nav-overlay-bg'),
    lg = document.querySelector('.nav-overlay-logo'),
    logo = gsap.utils.toArray('.nav-mobile .logo-holder');

  overlay.on(
    'opened.zf.offCanvas',
    function () {
      openMenu();
    }
  );

  overlay.on(
    'close.zf.offCanvas',
    function () {
      closeMenu();
    }
  );

  const openMenu = () => {
    menu.style.opacity = 0;

    gsap.killTweensOf(menu)

    gsap.set(its, {
      opacity: 0,
      y: 200
    })
    gsap.set(lg, {
      opacity: 0,
      x: '-100%'
    })

    tl && tl.kill()

    tl = gsap.timeline({
      onStart: function () {
        bg.style.transform = 'scale(var(--vpdr))'
        gsap.to(logo, {
          x: '-100%',
          duration: 0.3,
          transformOrigin: '0 50%',
          ease: 'power2.out'
        })
      },
      defaults: {
        duration: 1,
        ease: 'power4.out'
      }
    })

    tl.to(menu, {
      opacity: 1
    })
    tl.to(lg, {
      opacity: 1,
      x: 0,
      duration: 0.5,
      ease: 'power2.out'
    })
    .to(nav1, {
      opacity: 1,
      y: 0,
      stagger: .1
    }, "<.3")
    .to(nav2, {
        opacity: 1,
        y: 0,
        stagger: .1
      }, "<.6")
  }

  const closeMenu = () => {
    tl && tl.kill()

    gsap.to(menu, {
      opacity: 0,
      duration: .5,
      onStart: function () {
        bg.style.removeProperty('transform')
        gsap.to(lg, {
          x: '-100%',
          duration: 0.3,
          ease: 'power2.out'
        })
      },
      onComplete: function() {
        gsap.to(logo, {
          x: '0',
          duration: 0.5,
          transformOrigin: '0 50%',
          ease: 'power2.out'
        })
      }
    })
  }
}

export default Offcanvas